import { motion } from "framer-motion";
import Card from "./../Card/Card.js";
import { useRef, useState, useEffect } from "react";
import './Popovers.css';
import { Copy } from "lucide-react";

const Popovers = () => {
  const snippetContainerRef = useRef(null);
  const [showScanning, setShowScanning] = useState(false);

  const copySnippet = () => {
    if (snippetContainerRef.current) {
      const range = document.createRange();
      range.selectNode(snippetContainerRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      setShowScanning(true);
      setTimeout(() => setShowScanning(false), 1000);
    }
  };
  // OPEN universal popover
  const openPopover = (e) => {
    const popId = e.currentTarget.dataset.popover;
    const pop = document.getElementById(popId);
    if (!pop) return;

    pop.style.display = "block";
    pop.classList.add("seek");
  };

  // CLOSE universal popover
  const closePopover = (popId) => {
    const pop = document.getElementById(popId);
    if (!pop) return;

    const inner = pop.querySelector(".carve-popover-inner");

    inner.classList.add("popover-hide");
    pop.classList.add("waneout");

    setTimeout(() => {
      pop.classList.remove("seek", "waneout");
      inner.classList.remove("popover-hide");
      pop.style.display = "none";
    }, 220);
  };


  useEffect(() => {
    const handleOutside = (e) => {
      const openPop = document.querySelector(".carve-popover.seek");
      if (!openPop) return;

      if (!openPop.contains(e.target)) {
        closePopover(openPop.id);
      }
    };

    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, []);

  const popovers = [
    {
      id: "popOne",
      title: "Popover Default",
      content: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, Lorem ipsum dolor sit amet.., comes from a line in section 1.10.32.",
      className: "carve-popover-def"
    },
    {
      id: "popTwo",
      title: "Popover Top",
      content: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC,",
      className: "carve-popover-t"
    },

  ];

  return (
    <>
      <motion.div
        initial={{ y: 10, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -10, opacity: 0 }}
        transition={{ duration: 0.2 }}
        className="carve-flex-box"
        style={{ marginTop: "10rem", justifyContent: "space-around" }}
      >
        {popovers.map((p) => (
          <div key={p.id} style={{ position: "relative" }}>
            {/* ✅ TRIGGER (DATA POPOVER) */}
            <div
              className="carve-chips"
              data-popover={p.id}
              onClick={openPopover}
            >
              {p.title}
            </div>

            {/* ✅ POPOVER ELEMENT */}
            <div
              id={p.id}
              className={`carve-popover ${p.className}`}
              style={{ display: "none" }}
            >
              <div className="carve-popover-inner">
                <div className="carve-card">
                  <div className="carve-card-header">{p.title}</div>
                  <div className="carve-card-body">{p.content}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </motion.div>
      <div className={`center-container ${showScanning ? 'scanning' : ''}`} style={{ marginTop: "8rem" }}>

        <div className='snippet' ref={snippetContainerRef}>
          <pre>
            <code className="ColorSnippet">
              <span class="cn">&lt;div</span>
              <span class="cln"> className="</span><span class="cn">carve-chips</span><span class="cln">"</span>
              <span class="cln"> data-popover="</span><span class="cn">id</span><span class="cln">"</span>
              <span class="cln"> onClick={'{'}</span><span class="cn">openPopover</span><span class="cln">{'}'}&gt;</span><br />

              &nbsp;&nbsp;<span class="">popover default</span><br />

              <span class="cn">&lt;/div&gt;</span><br />
              <span className="cn">&lt;div</span>
              <span className="cln"> style="</span>position: relative;
              <span className="cln">"</span>
              <span className="cn">&gt;</span>
              <br />

              &nbsp;&nbsp;<span className="cn">&lt;div</span>
              <span className="cln"> class="</span><span className="cn">carve-popover carve-popover-def</span>
              <span className="cln">"</span> <span className="cln">style="</span>opacity: 1; transform: none;
              <span className="cln">"</span><span className="cn">&gt;</span>
              <br />

              &nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;div</span>
              <span className="cln"> class="</span><span className="cn">carve-card</span>
              <span className="cln">"</span><span className="cn">&gt;</span>
              <br />

              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;div</span>
              <span className="cln"> class="</span><span className="cn">carve-card-header</span>
              <span className="cln">"</span><span className="cn">&gt;</span>Popover Default
              <span className="cn">&lt;/div&gt;</span>
              <br />

              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;div</span>
              <span className="cln"> class="</span><span className="cn">carve-card-body</span>
              <span className="cln">"</span><span className="cn">&gt;</span>This is the default popover.
              <span className="cn">&lt;/div&gt;</span>
              <br />

              &nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;/div&gt;</span>
              <br />

              &nbsp;&nbsp;<span className="cn">&lt;/div&gt;</span>
              <br />

              <span className="cn">&lt;/div&gt;</span>
            </code>
          </pre>
          <br /><br />
          <pre>
            <code className="ColorSnippet">
              <span class="cn">&lt;div</span>
              <span class="cln"> className="</span><span class="cn">carve-chips</span><span class="cln">"</span>
              <span class="cln"> data-popover="</span><span class="cn">id</span><span class="cln">"</span>
              <span class="cln"> onClick={'{'}</span><span class="cn">openPopover</span><span class="cln">{'}'}&gt;</span><br />

              &nbsp;&nbsp;<span class="">popover top</span><br />

              <span class="cn">&lt;/div&gt;</span><br />
              <span className="cn">&lt;div</span>
              <span className="cln"> style="</span>position: relative;
              <span className="cln">"</span>
              <span className="cn">&gt;</span>
              <br />

              &nbsp;&nbsp;<span className="cn">&lt;div</span>
              <span className="cln"> class="</span><span className="cn">carve-popover carve-popover-t</span>
              <span className="cln">"</span> <span className="cln">style="</span>opacity: 1; transform: none;
              <span className="cln">"</span><span className="cn">&gt;</span>
              <br />

              &nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;div</span>
              <span className="cln"> class="</span><span className="cn">carve-card</span>
              <span className="cln">"</span><span className="cn">&gt;</span>
              <br />

              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;div</span>
              <span className="cln"> class="</span><span className="cn">carve-card-header</span>
              <span className="cln">"</span><span className="cn">&gt;</span>Popover Top
              <span className="cn">&lt;/div&gt;</span>
              <br />

              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;div</span>
              <span className="cln"> class="</span><span className="cn">carve-card-body</span>
              <span className="cln">"</span><span className="cn">&gt;</span>This is the top popover.
              <span className="cn">&lt;/div&gt;</span>
              <br />

              &nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;/div&gt;</span>
              <br />

              &nbsp;&nbsp;<span className="cn">&lt;/div&gt;</span>
              <br />

              <span className="cn">&lt;/div&gt;</span>
            </code>
          </pre>

        </div>
        <button aria-label="Copy Button" onClick={copySnippet}>
          <Copy/>
        </button>

      </div>
    </>
  );
}

const PopoverCard = () => {
  return (
    <div style={{ overflow: "visible" }} className="carve-visible-card">
      <Card CardTitle="Popovers" CardBody={<Popovers />} />
    </div>

  );
}
export default PopoverCard;